import { faMobile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Card, CardContent, TextField, Typography, useTheme } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { Actions } from '@base/core';
import TwoFactorIcon from '../../../assets/universal/fingerprint.svg';
import { StandardPopup } from '../../../components/common';

export function TwoFALoginCodePopup() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { twoFA, fetching } = useSelector((state: Core.StateType) => state.auth);
  const validationSchema = yup.object().shape({
    code: yup.string().required('No code provided.').min(5, 'Code is too short - should be 6 digits'),
  });

  return (
    <StandardPopup visible={twoFA.status.getLoginCode} onBackdropClick={() => null} width={425} hideClose>
      <Formik
        initialValues={{ code: '' }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(Actions().auth.provide2FAVerificationCode(values.code));
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, errors, touched, handleSubmit, values, submitForm }) => (
          <Form>
            <Card>
              <CardContent>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <img src={TwoFactorIcon} style={{ width: 72, height: 72, alignSelf: 'center' }} />
                </Box>
                <Typography variant="h2" sx={{ marginTop: 3, marginBottom: 3, textAlign: 'center' }}>
                  {t('two-factor-authentication')}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FontAwesomeIcon style={{ width: 44, height: 44, marginRight: 8 }} icon={faMobile} />
                    <Typography fontWeight="500" variant="subtitle1">
                      {t('two-factor-auth-decription', { hint: twoFA.phoneNumber })}
                    </Typography>
                  </Box>
                  <Field
                    style={{ marginTop: 24 }}
                    as={TextField}
                    label={t('enter-code')}
                    required
                    variant="outlined"
                    autoFocus
                    autoComplete="off"
                    name="code"
                    error={(touched.code && Boolean(errors.code)) || fetching.verify2FALoginCode.error}
                    helperText={(touched.code && errors.code) || fetching.verify2FALoginCode.error}
                  />
                  {fetching.verify2FALoginCode.error && (
                    <LoadingButton style={{ marginTop: 16 }} variant="contained" color="error" onClick={() => window.location.reload()}>
                      {t('retry-login')}
                    </LoadingButton>
                  )}
                  <LoadingButton style={{ marginTop: 16 }} variant="contained" color="success" loading={fetching.verify2FALoginCode?.fetching} onClick={submitForm} type="submit">
                    {t('verify')}
                  </LoadingButton>
                  <Typography style={{ marginTop: 10, textAlign: 'center' }} variant="subtitle2">
                    {t('two-factor-support-text') + ': '}
                    <a style={{ textDecoration: 'underline' }} href={'mailto: support@ibu-scope.com'}>
                      support@ibu-scope.com
                    </a>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Form>
        )}
      </Formik>
    </StandardPopup>
  );
}
